
import { useStore } from '@/store'
import { PageActionTypes } from '@/store/modules/page/action-types'
import { computed, defineComponent, inject, onMounted, ref, watch } from 'vue'
import * as StorageConstants from '@/constants/storage-constants'
import WebglCompatibilityService from '@/services/Three/webgl-compatibility.service'
import Analytics from '@/singletons/analytics'
import { FormActionTypes } from '@/store/modules/form/action-types'
import ConfirmDialog from '@/components/Abstract/ConfirmDialog.vue'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'ModeButton',
  components: {
    ConfirmDialog
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const isThreeMode = computed(() => store.getters.isThreeMode)
    const getShowEventName = ref(determineShowEventName())
    let visible = ref(true)
    let showInstruction = false

    onMounted(() => {
      visible.value = WebglCompatibilityService.isWebGLAvailable()
    })

    // prettier-ignore
    watch(() => isThreeMode.value, (isThreeMode) => {
      if(showInstruction) {
         emitter.emit('showInstruction')
         showInstruction = false
      }
    })

    const onClick = () => {
      emitter.emit(determineShowEventName())
    }

    const onYes = () => {
      changeMode()
    }

    function changeMode() {
      const useThree = !isThreeMode.value
      try {
        store.dispatch(PageActionTypes.SET_THREE_MODE, useThree)
        store.dispatch(FormActionTypes.SET_CURRENT_TAB, 0)
        
        showInstruction = true
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
      try {
        localStorage.setItem(StorageConstants.renderingmode, JSON.stringify(!useThree))
      }
      catch(err) {
        // on some browser like LINE, there is no localstorage; ignore that error
        console.error(err)
      }
      Analytics.instance.sendModeChangeEvent(useThree)
    }

    function determineShowEventName() {
      return 'showModeChange' + (props.isMobile ? 'mobile' : 'desktop')
    }

    return {
      visible,
      isThreeMode,
      onClick,
      onYes,
      getShowEventName
    }
  }
})
